import React from 'react';

interface HeroSectionProps {
  onOpenAuth: () => void;
}

export const HeroSection: React.FC<HeroSectionProps> = ({ onOpenAuth }) => {
  return (
    <section className="fs-hero-glow" style={{ minHeight: '88vh', display: 'flex', alignItems: 'center' }}>
      <div className="fs-page" style={{ paddingTop: 64, paddingBottom: 96, width: '100%' }}>
        <div style={{ maxWidth: 640 }}>

          {/* Status pill */}
          <div className="fs-hero-anim fs-hero-delay-1" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 24 }}>
            <div className="fs-pulse-dot" />
            <span style={{
              fontFamily: 'var(--fs-font-body)',
              fontSize: 12,
              fontWeight: 600,
              color: 'var(--fs-text-muted)',
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
            }}>Public Beta - Now open</span>
          </div>

          {/* Headline */}
          <h1 className="fs-hero-anim fs-hero-delay-2" style={{
            fontFamily: 'var(--fs-font-headline)',
            fontWeight: 500,
            fontSize: 'clamp(40px, 8vw, 64px)',
            lineHeight: 1.0,
            letterSpacing: '-0.02em',
            color: 'var(--fs-text)',
            marginBottom: 24,
          }}>
            Design tools built<br />by a wrap<br /><span style={{ color: 'var(--fs-cyan)' }}>designer.</span>
          </h1>

          {/* Subline */}
          <p className="fs-hero-anim fs-hero-delay-3" style={{
            fontFamily: 'var(--fs-font-body)',
            fontSize: 'clamp(16px, 2vw, 18px)',
            color: 'var(--fs-text-muted)',
            lineHeight: 1.6,
            marginBottom: 12,
            maxWidth: 480,
          }}>
            MockGen, StyleFinder, Reframe. Three apps for designers, car enthusiasts, and anyone who works with visuals.
          </p>
          <p className="fs-hero-anim fs-hero-delay-3" style={{
            fontFamily: 'var(--fs-font-body)',
            fontSize: 13,
            color: 'var(--fs-text-disabled)',
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            marginBottom: 32,
            maxWidth: 480,
          }}>
            Built by a wrap designer, for wrap designers.
          </p>

          {/* CTAs */}
          <div className="fs-hero-anim fs-hero-delay-4" style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
            <button className="fs-btn-primary" style={{ textAlign: 'center' }} onClick={onOpenAuth}>Join the Beta. It's Free.</button>
            <a href="#apps" className="fs-btn-ghost" style={{ textAlign: 'center' }}>See what's inside</a>
          </div>

          {/* Social proof */}
          <div className="fs-hero-anim fs-hero-delay-5" style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 40 }}>
            <div style={{ display: 'flex' }}>
              {['JW', 'MK', 'FR'].map((init, i) => (
                <div key={init} style={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  background: `var(--fs-surface-${i === 0 ? 'hi' : i === 1 ? 'mid' : 'low'})`,
                  border: '2px solid var(--fs-bg)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 10,
                  fontWeight: 700,
                  color: 'var(--fs-text-muted)',
                  marginLeft: i > 0 ? -8 : 0,
                }}>
                  {init}
                </div>
              ))}
              <div style={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                background: 'var(--fs-surface-hi)',
                border: '2px solid var(--fs-bg)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 10,
                fontWeight: 700,
                color: 'var(--fs-cyan)',
                marginLeft: -8,
              }}>+</div>
            </div>
            <p style={{ fontFamily: 'var(--fs-font-body)', fontSize: 13, color: 'var(--fs-text-muted)' }}>
              <span id="fs-counter" style={{ color: 'var(--fs-text)', fontWeight: 600 }}>247 designers</span>{' '}
              already in the beta
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};
